import React from "react";
import { Channel, Topic } from "../../../constants";
import { UserContextSelectors } from "../../../redux/selectors";
import { useDispatch, useSelector } from "react-redux";
import { Brand } from "../../../configurations";
import { Item } from "../Models";
import { LocalizationMessages } from "../../../localization/messages";
import { MenuActionCreators } from "../../../redux/action-creators";
import { MenuItem } from "../MenuItem";
import { MessageBrokerUtils } from "../../../utils";
import { BrandUtils } from "../../../utils/brandUtils";
import { MigrationUtils } from "../../../utils/migrationUtils";
import { useFeature } from "../../../hooks/useFeature";
import { AppFeatures } from "../../../constants/featureFlags";

const RegisterOrDepositMenuItem = () => {
  const isNative = useSelector(UserContextSelectors.isNative);
  const brandId = useSelector(UserContextSelectors.brandId);
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const isEagleMigrationStarted = useFeature(AppFeatures.EAGLE_MIGRATION);
  const dispatch = useDispatch();

  const depositButtonClicked = () => {
    MessageBrokerUtils.publish({
      channel: Channel.PAYMENT,
      topic: Topic.CTA_Quick_Deposit,
      headers: {
        publisher: "UAA"
      },
      data: {
        TabId: 16,
        Area: "Hamburger menu",
        Element: "Deposit button",
        Source: "Unified Client"
      }
    });
    dispatch(MenuActionCreators.hideHamburgerMenu());
  };

  const registerButtonClicked = () => {
    if (isEagleMigrationStarted && MigrationUtils.isSportRoMigrationOngoing()) {
      MigrationUtils.handleOpenRegistration(isNative);
    } else {
      MessageBrokerUtils.publish({
        channel: Channel.PLAYER,
        topic: Topic.CTA_NRS_Open,
        headers: {
          publisher: "UAA"
        }
      });
    }
    dispatch(MenuActionCreators.hideHamburgerMenu());
  };

  const getRegisterButton = () => {
    switch (brandId) {
      case Brand.Sport_Scasino:
      case Brand.Sport_Spoker: {
        return null;
      }
      case Brand.Sport_IT: {
        if (BrandUtils.isPokerClient()) return null;
      }
    }
    const registerItem = new Item({
      title: LocalizationMessages.registerButtonText,
      iconKey: "register"
    });

    return (
      <MenuItem
        item={registerItem}
        className="RegisterBtn"
        onClick={registerButtonClicked}
        dataTestId="uc-register"
      />
    );
  };

  const getDepositButton = () => {
    switch (brandId) {
      case Brand.Sport_Spoker: {
        return null;
      }
      default: {
        return (
          <MenuItem
            className="DepositBtn"
            onClick={depositButtonClicked}
            item={
              new Item({
                title: LocalizationMessages.deposit,
                iconKey: "deposit"
              })
            }
            dataTestId="uc-Cashier"
          />
        );
      }
    }
  };

  return isAuthenticated ? getDepositButton() : getRegisterButton();
};

export default React.memo(RegisterOrDepositMenuItem);
